module.exports = __webpack_public_path__ + "static/img/userlogo.7ab84846.svg";